import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBoatAvailableDifferentTimeComponent } from './customer-boat-available-different-time.component';
import { CustomerBoatAvailableDifferentTimeRoutingModule } from './customer-boat-available-different-time-routing.module';
import { CharterBuyflowVesselDetailResolve } from '../../public/charter-buyflow/charter-buyflow-vessel-detail/charter-buyflow-vessel-detail.resolve';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [CustomerBoatAvailableDifferentTimeComponent],
  imports: [
    CommonModule,
    CustomerBoatAvailableDifferentTimeRoutingModule,
    MatIconModule,
  ],
  providers: [],
})
export class CustomerBoatAvailableDifferentTimeModule {}
